import { createContext, type RefObject } from "react";

import type { MapViewApi } from "@map/mapiq-map-react/src/MapView";
import type { HereAndNowTab } from "@lib/logic";

import type { HereAndNowData } from "../data/useHereAndNowData";

export type HaNContextValue = HereAndNowData & {
  tab: HereAndNowTab;
  // Moves the page's map view, for handlers anywhere on the page. It's `null` until the floor's map is built.
  mapViewApiRef: RefObject<MapViewApi | null>;
};

export const HaNContext = createContext<HaNContextValue | null>(null);
